import api from "./api";

function isAllowedGoogleAccountsOAuthUrl(url) {
  try {
    const u = new URL(url);
    return (
      u.protocol === "https:" &&
      u.hostname.toLowerCase() === "accounts.google.com" &&
      u.pathname.includes("/o/oauth2")
    );
  } catch {
    return false;
  }
}

export async function getSearchConsoleAuthUrl() {
  const res = await api.get("/search-console/auth/start");
  return res.data?.url || null;
}

export async function startSearchConsoleOAuth() {
  const url = await getSearchConsoleAuthUrl();
  if (!url || !isAllowedGoogleAccountsOAuthUrl(url)) {
    console.error(
      "Search Console OAuth: missing URL or host not allowlisted (expected https://accounts.google.com/...)"
    );
    return;
  }
  window.location.href = url;
}

export async function disconnectSearchConsole() {
  await api.post("/search-console/disconnect");
}

export async function clearAndReconnectSearchConsole() {
  await disconnectSearchConsole();
  await startSearchConsoleOAuth();
}

export async function fetchSearchConsoleAnalytics(
  planId,
  opts = "30d",
  requestOpts = {}
) {
  const { signal } = requestOpts;
  const params = { planId, _t: Date.now() };
  if (typeof opts === "number") {
    params.days = opts;
  } else if (typeof opts === "string") {
    params.range = opts;
  } else if (opts && typeof opts === "object") {
    if (opts.range) params.range = opts.range;
    else if (opts.days != null) params.days = opts.days;
    else params.range = "30d";
  } else {
    params.range = "30d";
  }
  const res = await api.get("/search-console/analytics", { params, signal });
  return res.data;
}

export async function fetchSearchConsoleStatus() {
  const res = await api.get("/search-console/status");
  return res.data;
}
